import styled, { keyframes } from 'styled-components';
import Grid from 'styled-components-grid';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import {
  MoveLeftArrow,
  MoveRightArrow,
  CompletedIcon,
  MiniWhatsapp,
  Miniphone,
  SvgWhatsapp
} from '@images/svg/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  mt, mb, p, pb, pr, px, mr
} from 'styled-components-spacing';
import Checkbox from '@components/Checkbox';

import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';
import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';
import { FastField } from 'formik';

const { colors } = theme;

const spin = keyframes`
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
`;

export const StyledFastField = styled(FastField)`
border:1px solid #C9D8E8 !important;
`;

export const StyledItem = styled(Grid.Unit)`
  ${mt(3)}
  ${pb(3)}
  ${props =>
    props.submitButton
    && `
    display: flex;
    justify-content: center;
  `}
  ${props => (props.treatmentFormName ? pb(0) : pb(2))}
  ${props => props.treatmentFormName && mb(2)}
  ${props => props.treatmentFormName && mt(2)}
`;

export const StyledItemSpacing = styled(StyledItem)`
  ${pr(3.5)}
  ${pb(3)}
  font-size: 18px;
  line-height: 1.57;
  color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
  ${breakpoint('desktop')`
    ${px(0)}
    color: ${colors.darkBlue};
    color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
  `}
`;

export const TermsAndConditionsWrapper = styled.label`
  display: flex;
  align-items: center;
  color: ${colors.darkBlue};
  line-height: 1.5;
  font-size: 12px;
  ${mt(1)}
  ${mb(2)}
`;

export const StyledCheckbox = styled(Checkbox)`
  ${mr(4)}
  padding: 2px;
  background-color: ${colors.lightGray};
  box-sizing: content-box !important;
  margin-top: 6px;
  height: 40px;
  width: 40px;
  border: 1px solid ${colors.translucentDarkBlue};
  div {
    background-color: ${colors.lightGray};
    height: 40px;
    width: 40px;
  }
  svg {
    background-color: ${colors.lightGray};
    color: ${colors.navyGray};
  }
`;

export const StyledLabelTextWrapper = styled.div`
  ${breakpoint('desktop')`
    color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
    width: ${props => (props.treatmentFormName ? '100%' : '70%')} ;
  `}
  ${breakpoint('mobile', 'desktop')`
  color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
  `}
`;

export const StyledCategoryBody = styled.div`
border: 2px solid #C9D8E8;
width: 90%;
border-radius: 10px;
overflow: hidden;
margin: 20px;

&.half{
  width: 50%;
}

&.full{
  width: 100%;
  margin: 0px;
}
border-bottom:${props => (props.Block1hide || props.Block2hide ? 'none' : '')};

${breakpoint('mobile', 'desktop')`
  width: 90%;
  margin: 10px 0px;

  &.half{
    width: 90%;
  }

  &.full{
    width: 90%;
  }
  border-bottom:${props => (props.MobileHide ? '2px solid #C9D8E8' : 'none')};

`}

`;

export const StyledCategory = styled.div`
  font-size: 25px;
  text-align: center;
  padding: 10px 0px;
  color:#0A3D59;
  font-weight: 600;
  line-height: 30px;
  ${breakpoint('mobile', 'desktop')`
    font-size: 22px;
    padding: 3px 0px;
`}
`;

export const StyledVariant = styled.div`
  cursor: pointer;
  font-weight:600;
  color:#1680BB;
  padding: 10px;
  font-size: 20px;
  text-decoration: underline;
  line-height: 1.5;
  padding-bottom: 0px;
  ${breakpoint('mobile', 'desktop')`
    font-size: 15px;
    line-height: 1.4;
`}
`;

export const StyledVariantLink = styled.a`
  cursor: pointer;
  font-weight:600;
  color:#1680BB;
  font-size: 20px;
  text-decoration: underline;
  line-height: 1.5;
  padding-bottom: 0px;
  ${breakpoint('mobile', 'desktop')`
    font-size: 15px;
    line-height: 1.4;
  `}
`;

export const StyledLinks = styled.div`
  height: 250px;
  overflow: scroll;
  word-wrap: break-word;
  overflow-x: hidden;

  ::-webkit-scrollbar {
  width: 16px;
  ${breakpoint('mobile', 'desktop')`
  width: 6px;
  `}
}

::-webkit-scrollbar-track {
  background: white; 

}
 
::-webkit-scrollbar-thumb {
  background: #E3E3E3; 
  border-radius:5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #888; 
}
  display:${props => (props.Block1hide || props.Block2hide ? 'none' : 'block')};
  ${breakpoint('mobile', 'desktop')`
  display:${props => (props.MobileHide ? 'none' : 'block')};
  `}
`;

export const StyledRelatedPagesDesktop = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: center;
  margin: 3% 0%;
  ${breakpoint('mobile', 'desktop')`
    flex-direction:column;
  `}
`;
export const StyledRealtedPagesDiv = styled.div`
width: 45%;
display:${props => (props.hide ? 'flex' : 'none')};
justify-content: flex-start;
flex-direction: column;
${breakpoint('mobile', 'desktop')`
  width:100%;
  flex-direction:column;
  justify-content: center;
  align-items:center;
`}
`;

export const ContentBlock = styled.div`
padding-bottom: 1.5rem;
${RichTextStyle}
color:#093C59 !important;
h2{
  ${breakpoint('mobile', 'desktop')`
  font-size: 20px !important;
  line-height:1.3;
`}
  color:${props => (props.costsummary ? 'rgb(19, 108, 157) !important' : '')};
  font-size: ${props => (props.costsummary ? '28px !important' : '')};
  text-align: ${props => (props.costsummary ? 'center !important' : '')};
}
a{
  color:rgb(19,108,157);
}
${breakpoint('mobile', 'desktop')`
  padding-bottom: 0.5rem;
`}
`;

export const StyledInformation = styled.div`
  margin:5% 0%;
`;

export const StyledTestimonials = styled.div`
  margin: 5% 0%;
  display: flex;
  flex-direction: column;
  ${breakpoint('mobile', 'tablet')`
    align-items:center;   
 `}
`;

export const StyledGridWhyYapita = styled(Grid)`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  ${breakpoint('mobile', 'tablet')`
    flex-direction:column;   
 `}
  
`;

export const StyledTagLine = styled.div`
  color:#093C59;
  width: 100%;
  font-weight: 525;
  line-height: 1.5;
  font-size: 25px;
  ${breakpoint('mobile', 'desktop')`
  font-size: 20px;
`}
`;

export const ContentBlockHeading = styled.div`
  color:rgb(19, 108, 157);
  font-size: 28px;
  font-weight: 700;
  line-height: 1.4;
  ${mb(2)}
  ${breakpoint('mobile', 'desktop')`
    font-size: 22px;
    padding-bottom:10px;
  `}
`;

export const StyledContent = styled.div`
  color: #093C59;
  display: flex;
  align-items: flex-start;
  margin: 5% 0%;
  ${breakpoint('mobile', 'desktop')`
    flex-direction: column;
  `}
`;

export const StyledContentImage = styled.img`
  width: 400px;
  height: 250px;
  border-radius: 4%;
  ${breakpoint('mobile', 'desktop')`
    width: 100%;
    height: auto;
    padding:0% 5%;
`}
`;

export const StyledCategoryHeading = styled.div`
  border-bottom: 2px solid #C9D8E8;
  display: flex;
  justify-content: space-between;
  padding: 1% 5%;
  cursor: pointer;
`;

export const StyledCaretDown = styled.img`
width: 5%;
display:${props => (props.Block1hide || props.Block2hide ? 'none' : 'block')};
${breakpoint('mobile', 'desktop')`
  display:${props => (props.MobileHide ? 'none' : 'block')};
`}
${breakpoint('tablet', 'desktop')`
  width: 4%;`
}
`;

export const StyledCaretUp = styled.img`
width: 5%;
display:${props => (props.Block1hide || props.Block2hide ? 'block' : 'none')};
${breakpoint('mobile', 'desktop')`
  display:${props => (props.MobileHide ? 'block' : 'none')};
`}
${breakpoint('tablet', 'desktop')`
  width: 4%;`
}
`;

export const StyledContentText = styled.div`
  width:60%;
  display: flex;
  flex-direction: column;
  ${breakpoint('mobile', 'tablet')`
    width: 100%;
  `}
  ${breakpoint('tablet')`
    width: 100%;
  `}
`;
export const StyledImage = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  ${mt(5)}

  ${breakpoint('mobile', 'desktop')`
    width: 100%;
    ${mt(1)};
  `}
  ${breakpoint('tablet')`
    width: 100%;
  `}
`;
export const StyledRelatedPageHeading = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: rgb(19, 108, 157);
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  ${breakpoint('mobile', 'desktop')`
    font-weight:700;
    font-size: 22px;
    line-height:1.2;
  `}
`;
export const StyledTestimonialImages = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  ${breakpoint('mobile', 'tablet')`
    flex-direction:column;
  `}
  @media (min-width:450px) and (max-width:738px) {
    align-items:center;
    max-width:400px;
  }
`;

export const TestimonialImages = styled.img`
  width:30%;
  padding: 0px 15px;
  ${breakpoint('mobile', 'tablet')`
    width:100%;
    height: 100%;
    padding: 10px 0px;
  `}
`;

export const StyledWhyElement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width:30%;
  ${breakpoint('mobile', 'tablet')`
     flex-direction:row;
     align-items:center;
     width:auto;
`}
`;

export const StyledWhyBlock = styled.div`
  height: 32%;
  background-color: #ECFDFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 25px 0px;
  border-radius: 15px;
  ${breakpoint('mobile', 'tablet')`
    height: 150px;
    width: 45%;
  `}
`;

export const StyledWhyImage = styled.img`
  margin-top: 15px;
  width: 55px;
  height: 60px;
  background-color: #A2F1FA;
  padding: 5px 10px;
  border-radius: 8px;
  ${breakpoint('mobile', 'tablet')`
    margin-top: 10px;
    width:35px;
    padding:4px 10px;
 `}
 ${breakpoint('tablet', 'desktop')`
    margin-top: 10px;
    width:50px;
    padding:3px 7px;
  `}
`;

export const StyledWhyText = styled.div`
  text-align: center;
  font-size: 21px;
  color: #1D2B4E;
  font-weight: 700;
  padding:40px 10px;
  ${breakpoint('mobile', 'tablet')`
    line-height:1.25;
    font-size: 17px;
    padding:20px 10px;
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 20px;
    padding:20px 10px;
  `}
`;

export const LeftArrow = styled(MoveLeftArrow)`
  position: absolute;
  left: 0;
  top: 50%;
  width: 30px;
  height: 30px;
  ${breakpoint('tablet')`
    display: none;
   `}
`;

export const RightArrow = styled(MoveRightArrow)`
  position: absolute;
  right: 0px;
  top: 50%;
  width: 30px;
  height: 30px;
  ${breakpoint('tablet')`
    display: none;
   `}
`;

export const StyledInput = styled.input`
  ${mt(2)}
  padding: 10px;
  box-sizing: border-box;
  font-size: 1rem;
  border-radius: 12px;
  display: block;
  width: 100%;
  outline: none;
  border: 0px;
`;

export const StyledTestimonialWrapper = styled(Grid)`
  padding-top: 65px;

  ${breakpoint('mobile', 'tablet')`
    padding-top: 30px;
  `}
`;

export const StyledCompletedIcon = styled(CompletedIcon)`
  width: 50%;
  display: flex;
  margin: 0 auto;
`;

export const StyledNumbersSection = styled(Grid)`
  margin-bottom: 1rem;
`;

export const StyledMiniPhone = styled(Miniphone)`
  width: 30%;
  display: flex;
  margin-left: auto;
  padding-right: 20px;
  ${breakpoint('mobile', 'tablet')`
    width: 20%;
  `}
`;

export const StyledMiniWhatsapp = styled(MiniWhatsapp)`
  width: 30%;
  display: flex;
  padding-left: 20px;
  margin-right: auto;
  ${breakpoint('mobile', 'tablet')`
    width: 20%;
  `}
`;

export const StyledCoverMaxWidthNoBottomMargin = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;

export const StyledBannerTag = styled.div`
  display: flex;
  padding: 10px 0;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    padding: 5px 0;
  `}
`;

export const StyledScreenWrapper = styled.div`
  width: 100%;
  padding-bottom: 2rem;
`;

export const StyledFormHeadline = styled.h2`
  text-align: center;
  font-weight: 700;
  color: black;
  line-height: 1.5;
  font-size: 24px;
  margin-bottom: 1rem;
  padding-top: 1rem;
  ${breakpoint('mobile', 'tablet')`
     font-size: 20px;
    margin-bottom: 30px;
    padding-top: 0px;
`}

  ${breakpoint('tablet', 'desktop')`
  padding-top: 0px;
`}
`;

export const StyledBannerLeft = styled(Grid)`
  height: 70%;
  ${breakpoint('desktop')`
  padding-left: 30px;
  padding-right:5px;
  `}
`;

export const StyledTextArea = styled.textarea`
  resize: none;
  margin-top: 8px;
  outline: none;
  border: 0px;
  font-size: 16px;
  ${p(2)}
  font-weight: 400;
  max-height: 60px;
  border-radius: 12px;
  ::placeholder {
    font-size: 16px;
  }
  ${breakpoint('mobile', 'tablet')`
    ::placeholder {
    font-size: 12px;
    }
  `}
`;

export const LabelTitle = styled.h2`
  margin-bottom: 10px;
  text-transform: uppercase;
  text-align: center;
  font-size: 20px;
  font-weight: 800;
  ${breakpoint('desktop')`
    font-size: 36px;
    animation:
  `}
  @media screen and (max-width: 387px) {
    font-size: 7vw;
  }
`;

export const SyledCalculatorGrid = styled(Grid)`
  padding: 1rem;
  width: calc(100% - 2rem);
`;

export const StyledForWhyGrid = styled(Grid)`
  display:flex;
  flex-direction: column;
  padding-top: 10px;
`;

export const StyledBannerGrid = styled(Grid)`
  ${breakpoint('desktop')`
   padding: 40px 0;
 `}
`;

export const StyledImageOverButton = styled(Grid.Unit)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${breakpoint('mobile', 'tablet')`
  img{
    width: 70%;
  }
  
`}
  ${breakpoint('tablet', 'desktop')`
  img{
    width: 30%;
  }
  
`}
${breakpoint('desktop')`
  display: none;
`}
`;

export const StyledGrid = styled(Grid)`
  ${({ relative }) =>
    relative
    && `
   z-index: 2;
  `};
  ${breakpoint('mobile', 'tablet')`
`}
`;

export const StyledDoctorGrid = styled(Grid)`
  ${breakpoint('mobile', 'tablet')`
    width: 200%;
    ${({ scroll }) => scroll && 'transform: translateX(-50%)'};
  transition: 0.3s;
`}

  ${breakpoint('desktop')`
   min-height: 665px;
 `}
`;

export const StyledOverFlowScroll = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const StyledArrowWrapper = styled.div`
  width: calc(100% - 40px);
  position: relative;
  padding: 0 20px;
`;

export const StyledOnScreenCarouselElement = styled(Grid.Unit)``;

export const DescriptionImage = styled(LazyLoadImage)`
  max-height: 70vh;
  display: flex;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  height: auto;
  margin-bottom: 2rem;
`;

export const StyledFacilityGrid = styled(Grid)`
  ${breakpoint('desktop')`
   min-height: 500px;
 `}

  ${breakpoint('mobile', 'tablet')`
  width: 200%;
  transition: 0.3s;
  ${({ scroll }) => scroll && 'transform: translateX(-50%)'};

 `}
`;

export const StyledFormRow = styled(Grid)`
  margin-bottom: 1rem;

  ${breakpoint('mobile', 'tablet')`
    margin-bottom: 20px;
  `}
`;

export const StyledWhyGridUnit = styled(Grid.Unit)`
  padding: 20px;
`;

export const StyledBannerContent = styled(Grid.Unit)`
  padding: 60px 0px;
`;

export const StyledGridUnit = styled(Grid.Unit)`
  ${({ justifycenter }) =>
    justifycenter
    && `
 display: flex;
 justify-content: center; 
 `}
`;

export const StyledRenderGrid = styled(Grid.Unit)`
  padding: 20px 0;
`;

export const Details = styled.p`
  margin: 0;
  text-align: center;
  font-size: 14px;
  font {
    font-weight: 800;
  }
  ${breakpoint('desktop')`
    font-size: 24px;
  `}
  @media screen and (max-width: 400px) {
    font-size: 4vw;
  }
  ${({ br }) =>
    br
    && `
 border-right: 2px solid black;
 `}
`;

export const IconImage = styled.span`
  img {
    width: 26px;
    height: 26px;
  }
  ${breakpoint('mobile', 'desktop')`
  img{
    width: 20px;
    height: 25px;
  }
    
  `}
`;

export const BannerTopImage = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
  img {
    margin-left: 30px;
    width: auto;
    max-width: 70%;
  }

  ${breakpoint('mobile', 'desktop')`
   display: none;
  `}
`;

export const CostEstimateButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  width: 50%;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 22px;
  color: #5da8c2;
  border-radius: 8px;
  font-weight: 600;
  padding: 20px;
  background-color: white;
  line-height: 1.4;
  a {
  }
  img {
    height: 30px;
    width: 30px;
    padding-right: 20px;
  }
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
    width: 70%;
    padding: 10px;
    margin-top: 0px;
    margin-bottom: 30px
`}
  ${breakpoint('tablet', 'desktop')`
    font-size: 18px;
    width: 40%;
    padding: 10px;
    margin-top: 0px;
    margin-bottom: 30px
`}
`;

export const StyledLiItem = styled.div`
  display: flex;
  margin-top: 20px;
  img {
    width: 16px;
    height: 16px;
    margin-right: 30px;
    margin-top: 9px;
    ${({ innerli }) =>
    innerli
      && `
      margin-top: 12px;
      height: 6px;
      width: 6px
  `}
    ${breakpoint('mobile', 'tablet')`
     margin-top: 12px;
     margin-right: 20px;
    `}
  }

  ${breakpoint('mobile', 'tablet')`
    margin-top: 10px;
  `}
`;

export const StyledLiText = styled.div`
  height: 100%;
  font-size: 20px;
    line-height: 34px;
    font-weight: 600;
    color: #2485a6;
    ${breakpoint('tablet')`
      font-size: 20px;
      line-height: 34px;
    `}
    ${breakpoint('desktop')`
      font-size: 20px;
      line-height: 34px;
    `}
  ${breakpoint('mobile', 'tablet')`
    margin-bottom: 0px;
    font-size: 16px;
    line-height: 30px;
  `}
`;

export const StyledWhatsappIcon = styled(SvgWhatsapp)`
  margin-right: 30px;
  height: 30px;
  width: 30px;
  path {
    stroke: #5da8c2;
    fill: #5da8c2;
  }
  ${breakpoint('mobile', 'tablet')`
    margin-right: 25px;
  `}
`;

export const StyledBannerTagsWrapper = styled.div`
padding:5% 0%;
  height: auto;
  width: -webkit-fill-available;
`;

export const StyledTagsImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${breakpoint('mobile', 'desktop')`
   padding: 10px 0;
  `}
`;

export const BannerDoctorImage = styled(LazyLoadImage)`
  ${breakpoint('desktop')`
  height: calc(100% + 50px);
  max-width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 2;
  `}
  ${breakpoint('mobile', 'desktop')`
      max-width: 100%;
      max-height: calc(100% + 5px);
   display: flex;
   margin: 0 auto;
   position: absolute;
   bottom: 0;
   right: 0;
  `}
`;

export const BannerDoctor = styled(Grid.Unit)`
  ${breakpoint('tablet')`
  display: flex;
  justify-content: center;
  position: relative;`}
  ${breakpoint('mobile', 'tablet')`
 position: relative;
`}
`;

export const StyledBannerDoctorGrid = styled(Grid)`
  height: 100%;
`;

export const MainHealine = styled.h2`
  color: ${({ textcolor }) => textcolor || 'black'};
  ${({ center }) => center && 'text-align: center'};
  width: 100%;
  font-weight: 800;
  line-height: 1.5;
  font-size: 42px;
  ${breakpoint('tablet', 'desktop')`
    font-size: 38px;
    padding-top: 2rem;
    margin-bottom: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
     font-size: 24px;
    line-height: 1.5;
    padding-top: 1rem;
    margin-bottom: 1rem;
    ${({ marketing }) => marketing && 'font-size: 17px'};
    ${({ nomargin }) => nomargin && 'margin-bottom: 0px'};
`}
`;

export const BannerTopHeadline = styled.h1`
color: ${({ textcolor }) => textcolor || 'black'};
  width: 100%;
  font-weight: 800;
  line-height: 1.5;
  font-size: 42px;
  ${breakpoint('tablet', 'desktop')`
    font-size: 38px;
    padding-top: 2rem;
    margin-bottom: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
     font-size: 25px;
    line-height: 1.5;
    padding-top: 1rem;
    margin-bottom: 1rem;
    ${({ marketing }) => marketing && 'font-size: 17px'};
    ${({ nomargin }) => nomargin && 'margin-bottom: 0px'};
`}
${breakpoint('tablet', 'desktop')`
      ${({ why }) => why && 'margin-left: 100px'};
  `}
  ${breakpoint('desktop')`
          ${({ why }) => why && 'margin-left: 150px'};
  `}
  padding-top: 1rem;
`;

export const MainMidHeadline = styled.h3` 
color: ${({ textcolor }) => textcolor || 'black'};
  ${({ center }) => center && 'text-align: center'};
  width: 100%;
  font-weight: 800;
  line-height: 1.5;
  font-size: 42px;
  ${breakpoint('tablet', 'desktop')`
    font-size: 38px;
    padding-top: 2rem;
    margin-bottom: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
  text-align: start;
     font-size: 24px;
    line-height: 1.5;
    padding-top: 1rem;
    margin-bottom: 1rem;
    ${({ marketing }) => marketing && 'font-size: 17px'};
    ${({ nomargin }) => nomargin && 'margin-bottom: 0px'};
`}

width: unset;
${({ why3 }) => why3 && 'padding-right: 30px'};
text-align: center;
${breakpoint('mobile', 'tablet')`
font-size: 18px;
margin-bottom: 15px;
padding-top: 0px;
`}
${breakpoint('tablet', 'desktop')`
font-size: 25px;
padding-top: 0px;
`}
  ${breakpoint('desktop')`
    font-size: 26px;
  `}
  
`;

export const MainSubHealine = styled.h2`
padding-top: 1.5rem;
  color: ${({ textcolor }) => textcolor || 'black'};
  ${({ center }) => center && 'text-align: center'};
  ${({ mt }) => mt && 'margin-top: 30px'};
  font-size: 28px;
  line-height: 1.4;
  font-weight: 700;
  margin-bottom: 1.5rem;
  ${({ center }) =>
    center
    && `
    text-align: center;
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 22px;
  `}
  ${breakpoint('mobile', 'tablet')`
  padding-top: 1.5rem;
    font-size: 22px;
    margin-bottom: 1.5rem;
  `}
`;

export const ContactImmediatelyHeadline = styled(StyledFormHeadline)`
  width: 100%;
  color: white;
  border-top: 2px solid white;
  text-align: center;
  padding-top: 20px;
`;

export const BannerSubHeadline = styled(MainSubHealine)`
  padding-top: 0px;
`;

export const TextContent = styled.div`
  font-size: 29px;
  padding-bottom: 2.5rem;
  ${RichTextStyle}
  color: ${({ textcolor }) => textcolor || 'black'};
  ${breakpoint('mobile', 'desktop')`
    font-size: 20px;
  `}
`;

export const FormWrapper = styled(Grid.Unit)`
  margin-top:20px;
  margin-bottom: 25px;
  background-color: white;
  border: 1px solid #C9D8E8;
  border-radius: 10px;
  padding: 10px 20px;
  padding-bottom: 0px;
  ${breakpoint('mobile', 'tablet')`
    padding: 10px 10px;
    padding-bottom: 0px;
  `}
`;

export const TagsTextContent = styled(TextContent)`
  font-size: 22px;
  font-weight: 600;
  padding: 10px;
  ${breakpoint('mobile', 'tablet')`
   font-size: 17px;
   padding: 0px;
   padding-left: 15px;
`}
  ${breakpoint('tablet')`
 padding-bottom: 10px;
`}
`;

export const StyledSeeMore = styled.a`
  font-size: 22px;
  color: #2485a6;
  cursor: pointer;
  margin: 0 auto;
  @media screen and (max-width: 400px) {
    font-size: 5vw;
  }
`;

export const StyledFlexCenter = styled(Grid)`
  display: flex;
  justify-content: center;
  margin-bottom: ${props => (props.blogs ? '2rem' : '0rem')};
  margin-top: ${props => (props.blogs ? '3rem' : '4rem')};
`;

export const StyledLabel = styled.label`
  color: black;
`;

export const StyledSubmitButton = styled.div`
  text-align: center;
  cursor: pointer;
  width: 70%;
  margin: 1rem auto;
  font-size: 22px;
  color: #FFFFFF;
  border-radius: 12px;
  font-weight: 600;
  padding: 10px;
  background-color: #287FB0;
  ${({ disable }) =>
    disable
    && `
    opacity: 0.2;
    pointer-events: none;

    cursor: none;
  `};
  ${breakpoint('mobile', 'tablet')`
    width: 60%;
    font-size: 20px;
    padding: 15px;
  `}
`;

export const StyledWhyElementWrapper = styled.div`
  position: relative;

  ${breakpoint('mobile', 'tablet')`
   padding-left: 10px;
   background: #FFFFFF;
   box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  `}
`;

export const HeadingWithNoHeight = styled.div`
  display: flex;
  height: 0px;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const StyledWhyAbsoluteHeading = styled.h2`
color: ${({ textcolor }) => textcolor || 'black'};
border-radius: 50%;
  ${({ center }) => center && 'text-align: center'};
  width: 100%;
  font-weight: 800;
  line-height: 1.5;
  font-size: 42px;
  ${breakpoint('tablet', 'desktop')`
    font-size: 38px;
    padding-top: 2rem;
    margin-bottom: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
  
     font-size: 24px;
    line-height: 1.5;
    padding-top: 1rem;
    margin-bottom: 1rem;
    ${({ marketing }) => marketing && 'font-size: 17px'};
    ${({ nomargin }) => nomargin && 'margin-bottom: 0px'};
`}
${breakpoint('tablet', 'desktop')`
      ${({ why }) => why && 'margin-left: 100px'};
      background-color:  ${theme.colors.greyishLightBlue};
  `}
  ${breakpoint('desktop')`
          ${({ why }) => why && 'margin-left: 150px'};
          background-color:  ${theme.colors.greyishLightBlue};
  `}

  padding: 1rem;
  ${breakpoint('tablet')`
   position: absolute; 
   top: 50%;
   left: 50%;
   -ms-transform: translate(-50%, -50%);
   transform: translate(-50%, -50%);
   width: fit-content;
`}
  ${breakpoint('mobile', 'tablet')`
 font-size: 32px;
 margin-bottom: 0px;
`}
`;

export const StyledLineLeft = styled.div`
  position: absolute;
  border-left: 2px solid #2485a6;
  border-style: dashed;
  border-right: 0px;
  border-top: 0px;
  border-bottom: 0px;
  height: 100%;
  top: 0;
  left: 7.5px;
  z-index: 2;
  ${breakpoint('mobile', 'tablet')`
  border-left: 2px solid #2485a6;
  border-style: dashed;
  border-right: 0px;
  border-top: 0px;
  border-bottom: 0px;
  left: 17px;
    ${({ mobileshow }) => !mobileshow && 'display: none'};
  `}
`;

export const StyledGridUnitDesktopVisible = styled(Grid.Unit)`
  ${({ center }) =>
    center
    && `
 display: flex;
 align-iten: center;
`}
  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;

export const StyledGridDesktopVisible = styled(Grid)`
  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;

export const StyledGridMobileVisible = styled(Grid)`
  ${mt(4)}
  ${breakpoint('desktop')`
    display: none;
  `}
`;

export const MetaTags = styled.meta``;

export const StyledGridUnitMobileVisible = styled(Grid.Unit)`
  ${breakpoint('desktop')`
    display: none;
  `}
`;

export const StyledOrderedList = styled.ul`
  position: relative;
  width: fit-content;
  margin: auto;
  > li {
    ${mt(3)}
    ${mb(3)}
    display: list-item;
    font-size: 20px;
    list-style-type: disc;
    line-height: 1.3;
    margin-left: 16px;
    font-weight: 600;
    color: #2485a6;
    @media screen and (max-width: 400px) {
      font-size: 5vw;
      margin-bottom: 20px;
      line-height: 24px;
      ${mt(3)}
      ${mb(3)}
      margin-left: 1rem;
    }
    ${breakpoint('tablet')`
      font-size: 20px;
      line-height: 39px;
    `}
    ${breakpoint('desktop')`
      font-size: 20px;
      line-height: 34px;
    `}
  }
  ${breakpoint('mobile', 'tablet')`
      padding: 10px;
      margin: unset;
    `}
`;

export const DocumentsWrapper = styled(Grid)`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

export const StyledSubline = styled.span`
  ${mt(4)}
  color: ${colors.translucentDarkBlue};
  background: #83bce0;
  padding: 10px;
  border-radius: 6px;
`;

export const StyledValidationMessage = styled.div`
  ${({ ValidationMessage }) => ValidationMessage
  && `
    padding-top:5px;
    font-size: 13px;
    color:red;
    text-align: center;
  `}
  ${({ ValidationMessage }) => !ValidationMessage
  && `
    display:none;
  `}
`;

export const StyledLoading = styled(FontAwesomeIcon)`
  display: ${props => (props.loading ? 'block !important' : 'none !important')}; 
  align-items: center;
  justify-content: center;
  position: relative;
  top:25%;
  left: 50%; 
  transform: translate(-50%, -50%); 
  animation: ${spin} 3s linear infinite;
  color: #5fb9d7; 
`;

export const StyledCardsMaxWidth = styled.div`
  max-width: 1400px;
  padding: 0 1rem;
  margin: auto;
  margin-top: 2rem;
  ${breakpoint('mobile', 'desktop')`
   padding: 0px;
  `}
`;

export const StyledSwiper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0px !important
  }

  .swiper-container-android .swiper-slide, .swiper-wrapper {
    margin-bottom: 2rem;
  }

  .swiper-button-prev,
.swiper-button-next {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 40px;
  height: 40px;
   top: 50%;
  transform: translateY(-50%);
  z-index: 10;

}
 .swiper-button-prev {
  left: -10px;
  background-image: url('/svg/packageScreen/prev-arrow.svg');
}

.swiper-button-next {
   right: -10px;
   background-image: url('/svg/packageScreen/next.svg');
}
.swiper-button-prev::after,
.swiper-button-next::after {
  display: none;
}

   .swiper-slide {
    /* transform: scale(0.95); */
    transition: transform 0.3s ease;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .swiper-button-disabled {
  opacity: 0.3;
  pointer-events: none;
}

`;
